import { get } from 'lodash';
import appUtils from 'src/components/appUtils';

const utils = {};

utils.Response401 = {
  success: false,
  status: 401
};
utils.DEFAULT_TIMEOUT = 60000;

utils.commonHeaders = {
  'Content-Type': 'application/json'
  // hardcoded api key for the Digital Resource local copy
  // 'x-api-key': '46f20464-d695-46d0-bffc-f13a9d4c814e'
};

utils.PUBLIC_ROUTES = [
  '/user/me',
  '/login',
  '/sign-up',
  '/recovery-email',
  '/forgot-password',
  '/recover-password',
  '/saved-password',
  '/reset-password',
  '/success',
  '/dashboard/email-review',
  '/dashboard/email-feedback',
  '/dashboard/pulse-review',
  '/pulse-shared-link',
  '/dashboard/email-goal',
  '/dashboard/onboarding',
  '/builder',
  '/'
];

utils.isPublicRoute = (pathname) => utils.PUBLIC_ROUTES.some((publicRoute) => {
  if (publicRoute === '/pulse-shared-link') {
    return pathname.startsWith('/pulse-shared-link');
  }
  return new RegExp(publicRoute).test(pathname);
});

utils.handle401 = () => {
  try {
    appUtils.logUserOut();
    return utils.Response401;
  } catch (error) {
    console.error('utils.handle401', error);
    throw error;
  }
};

utils.logAxiosError = (prefix, error, endpoint, requestData) => {
  try {
    console.error(prefix, 'axios error curated', {
      errorMessage: get(error, 'message', 'unknown error message'),
      errorData: get(error, 'response.data', 'unknown error'),
      errorResponse: get(error, 'response', 'unknown error response'),
      errorCode: get(error, 'code', 'unknown error code'),
      requestMethod: get(error, 'config.method', 'unknown method'),
      endpoint,
      requestData,
      pathname: get(window, 'location.pathname'),
      error
    });
  } catch (err) {
    console.error('logAxiosError', err, {
      error,
      endpoint,
      requestData
    });
  }
};

export default utils;
